<template>
    <multiselect
        v-bind:value="value"
        v-bind:options="nameOptions"
        v-bind:taggable="true"
        v-bind:internalSearch="false"
        v-bind:id="id"
        v-bind:placeholder="placeholder"
        tag-placeholder="Als Aufgabe übernehmen"
        v-on:input="select"
        v-on:tag="select"
        v-on:search-change="nameSearch = $event"
        v-on:close="select(nameSearch)"
    >
        <span slot="caret"></span>
    </multiselect>
</template>

<script>
import { Multiselect } from '@components/form';
import { PORTAL_TODO_NAMES } from '../todos';

/**
 * Task name for portal tasks: the predefined names (Stornotermin — the one the
 * dashboard shows as deadline) or any free text, like the staff form/Todo.vue.
 * Text that was typed but not confirmed with Enter is kept on close.
 */
export default {
    name: 'todo-name-select',

    components: { Multiselect },

    props: {
        value: { type: String, default: '' },
        id: { type: String, default: null },
        placeholder: { type: String, default: 'z.B. Teilnehmerliste abgeben' },
    },

    data() {
        return { nameSearch: '' };
    },

    computed: {
        // A free-text name being edited has to be in the list to show as selected.
        nameOptions() {
            return this.value && !PORTAL_TODO_NAMES.includes(this.value)
                ? [...PORTAL_TODO_NAMES, this.value]
                : PORTAL_TODO_NAMES;
        },
    },

    methods: {
        select(name) {
            if (name && name.trim()) {
                this.$emit('input', name.trim());
            }
        },
    },
};
</script>
